import { type Node, useReactFlow } from "@xyflow/react";
import { useEffect } from "react";
import "./InternalDebuggerZoomPanControls.scss";

export interface DebuggerZoomPanControlsProps {
  fitViewKey: number;
  panTo?: Node;
}

const DebuggerZoomPanControls = (props: DebuggerZoomPanControlsProps) => {
  const { fitViewKey, panTo } = props;
  const { fitView, setCenter } = useReactFlow();

  useEffect(() => {
    setTimeout(() => {
      fitView({ padding: 0.2 });
    }, 200);
  }, [fitViewKey]);

  useEffect(() => {
    if (panTo) {
      setCenter(panTo.position.x, panTo.position.y, { zoom: 1 });
    }
  }, [panTo]);

  return null;
};

export default DebuggerZoomPanControls;
